import {
  Bloom,
  ChromaticAberration,
  DotScreen,
  EffectComposer,
  Noise,
  ToneMapping,
} from "@react-three/postprocessing";
import { Vector2 } from "three";
import { EffectsTypes, FxConfigProps, NvsEffectsSelectorProps } from "./types";
import { FxConfigTypeMap, effectSelectorProps } from "./constants";

function reduceEffectsToConfig(effectArray: EffectsTypes[]): FxConfigProps {
  // Everything is disabled by default
  const DEFAULT_EFFECTS_CONFIG = {
    bloom: false,
    dotScreen: false,
    noise: false,
    chromaticAberration: false,
    toneMapping: false,
  };
  return effectArray.reduce(
    (acc, effect) => ({
      ...acc,
      [FxConfigTypeMap[effect]]: true,
    }),
    { ...DEFAULT_EFFECTS_CONFIG },
  );
}

export const NvsEffectsSelector: React.FC<NvsEffectsSelectorProps> = ({
  effects,
  enabled,
}) => {
  const dpr = window.devicePixelRatio;
  const fxConfig = reduceEffectsToConfig(
    effects.map((effect) => effect.effectType as EffectsTypes),
  );
  return (
    <EffectComposer enabled={enabled}>
      <>
        {fxConfig.bloom && (
          <Bloom
            luminanceThreshold={effectSelectorProps.bloom.luminanceThreshold}
            luminanceSmoothing={effectSelectorProps.bloom.luminanceSmoothing}
          />
        )}
        {fxConfig.dotScreen && (
          <DotScreen
            angle={Math.PI * effectSelectorProps.dotScreen.angle}
            scale={effectSelectorProps.dotScreen.scale / dpr}
            opacity={effectSelectorProps.dotScreen.opacity}
            blendFunction={effectSelectorProps.dotScreen.blendFunction}
          />
        )}
        {fxConfig.noise && (
          <Noise opacity={effectSelectorProps.noise.opacity} />
        )}
        {fxConfig.chromaticAberration && (
          <ChromaticAberration
            offset={
              new Vector2(
                effectSelectorProps.chromaticAberration.offset[0] / dpr,
                effectSelectorProps.chromaticAberration.offset[1] / dpr,
              )
            }
            blendFunction={
              effectSelectorProps.chromaticAberration.blendFunction
            }
            radialModulation={false}
            modulationOffset={0}
          />
        )}
        {fxConfig.toneMapping && <ToneMapping />}
      </>
    </EffectComposer>
  );
};

export default NvsEffectsSelector;
